// (function() {

//   var COLLECTION_IDS_TARGET = [
//     32800669757,
//     39435796541,
//     39433470013,
//     32788447293,
//     32788512829,
//     39442579517,
//     32804307005,
//     284172714045
//   ];

//   var CUSTOM_HTML = function(collectionId) {
//     return '<div class="boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2" data-id="14836191461741" data-page="1">' +
//              '<div class="reeview-app-widget videowise-collection-tile" ' +
//                'id="reeview-app-widget_693820e1d8b09100468ee1b9" ' +
//                'data-widget-id="693820e1d8b09100468ee1b9" ' +
//                'data-collection-id="' + collectionId + '">' +
//              '</div>' +
//            '</div>';
//   };

//   if (typeof ProductList !== 'undefined') {
//     var originalCompileTemplate = ProductList.prototype.compileTemplate;
//     ProductList.prototype.compileTemplate = function(data) {
//       var html = originalCompileTemplate.call(this, data);
//       var currentCollectionId = boostPFSConfig.general.collection_id;

//       if (COLLECTION_IDS_TARGET.includes(Number(currentCollectionId))) {
//         var $container = this.$element || jQ('.boost-pfs-product-list');
//         var $products = $container.find('.boost-pfs-filter-product-item');

//         if ($products.length > 7 && $container.find('.reeview-app-widget').length === 0) {
//           jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(6));
//         }
//       }

//       return html;
//     };

//     var originalAfterRender = ProductList.prototype.afterRender;
//     ProductList.prototype.afterRender = function(data) {
//       if (originalAfterRender) originalAfterRender.call(this, data);
//       var currentCollectionId = boostPFSConfig.general.collection_id;

//       if (COLLECTION_IDS_TARGET.includes(Number(currentCollectionId))) {
//         var $container = this.$element || jQ('.boost-pfs-product-list');
//         var $products = $container.find('.boost-pfs-filter-product-item');

//         if ($products.length > 7 && $container.find('.reeview-app-widget').length === 0) {
//           jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(6));
//         }
//       }
//     };
//   }

// })();

// (function() {

//   var COLLECTION_IDS_TARGET = [
//     32788217917
//   ];

//  var CUSTOM_HTML = function(collectionId) {
//   return '<div class="boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2">' +
//            '<div class="reeview-app-widget videowise-collection-tile" ' +
//              'id="reeview-app-widget_69731efec180ec041b9e51e5" ' +
//              'data-widget-id="69731efec180ec041b9e51e5" ' +
//              'data-collection-id="' + collectionId + '">' +
//            '</div>' +
//          '</div>';
// };

//   if (typeof ProductList !== 'undefined') {

//     var originalCompileTemplate = ProductList.prototype.compileTemplate;
//     ProductList.prototype.compileTemplate = function(data) {
//       var html = originalCompileTemplate.call(this, data);
//       var currentCollectionId = boostPFSConfig.general.collection_id;

//       if (COLLECTION_IDS_TARGET.includes(Number(currentCollectionId))) {
//         var $container = this.$element || jQ('.boost-pfs-product-list');
//         var $products = $container.find('.boost-pfs-filter-product-item');

//         if ($products.length > 7 && $container.find('.reeview-app-widget').length === 0) {
//           jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(18));
//         }
//       }

//       return html;
//     };

//     var originalAfterRender = ProductList.prototype.afterRender;
//     ProductList.prototype.afterRender = function(data) {
//       if (originalAfterRender) originalAfterRender.call(this, data);
//       var currentCollectionId = boostPFSConfig.general.collection_id;

//       if (COLLECTION_IDS_TARGET.includes(Number(currentCollectionId))) {
//         var $container = this.$element || jQ('.boost-pfs-product-list');
//         var $products = $container.find('.boost-pfs-filter-product-item');

//         if ($products.length > 7 && $container.find('.reeview-app-widget').length === 0) {
//           jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(18));
//         }
//       }
//     };
//   }

// })();
(function() {
  
  var COLLECTION_ID_TARGET = 39433470013;
  var COLLECTION_ID_TARGET_1 = 32788447293;
  var COLLECTION_ID_TARGET_2 = 32788512829;

  var CUSTOM_HTML = function(collectionId) {
    return '<div class="boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2" data-id="14836191461741" data-page="1"><div class="reeview-app-widget videowise-collection-tile" ' +
           'id="reeview-app-widget_693820e1d8b09100468ee1b9" ' +
           'data-widget-id="693820e1d8b09100468ee1b9" ' +
           'data-collection-id="' + collectionId + '"></div></div>';
  };

  if (typeof ProductList !== 'undefined') {
    var originalCompileTemplate = ProductList.prototype.compileTemplate;
    ProductList.prototype.compileTemplate = function(data) {
      var html = originalCompileTemplate.call(this, data);
      var currentCollectionId = boostPFSConfig.general.collection_id;

      if (currentCollectionId == COLLECTION_ID_TARGET || currentCollectionId == COLLECTION_ID_TARGET_1 || currentCollectionId == COLLECTION_ID_TARGET_2  ) {
        var $container = this.$element || jQ('.boost-pfs-product-list');
        var $products = $container.find('.boost-pfs-filter-product-item');

        if ($products.length > 6 && $container.find('.reeview-app-widget').length === 0) {
          jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(6));
        }
      }
      return html;
    };

    var originalAfterRender = ProductList.prototype.afterRender;
    ProductList.prototype.afterRender = function(data) {
      if (originalAfterRender) originalAfterRender.call(this, data);
      var currentCollectionId = boostPFSConfig.general.collection_id;

      if (currentCollectionId == COLLECTION_ID_TARGET || currentCollectionId == COLLECTION_ID_TARGET_1 || currentCollectionId == COLLECTION_ID_TARGET_2  ) {
        var $container = this.$element || jQ('.boost-pfs-product-list');
        var $products = $container.find('.boost-pfs-filter-product-item');

        if ($products.length > 6 && $container.find('.reeview-app-widget').length === 0) {
          jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(6));
        }
      }
    };
  }
})();
(function() {
  
  var NEW_COLLECTION_ID_TARGET = 284172714045;
  var NEW_COLLECTION_ID_TARGET_1 = 39435796541;
  var NEW_COLLECTION_ID_TARGET_2 = 39442579517;
  var NEW_COLLECTION_ID_TARGET_3 = 32804307005;
  var NEW_COLLECTION_ID_TARGET_4 = 32800669757;

  var CUSTOM_HTML = function(collectionId) {
    return '<div class="boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2" data-id="14836191461741" data-page="1"><div class="reeview-app-widget videowise-collection-tile" ' +
           'id="reeview-app-widget_6a91ebf4f27ab86b7f119e22" ' +
           'data-widget-id="6a91ebf4f27ab86b7f119e22" ' +
           'data-collection-id="' + collectionId + '"></div></div>';
  };

  if (typeof ProductList !== 'undefined') {
    var originalCompileTemplate = ProductList.prototype.compileTemplate;
    ProductList.prototype.compileTemplate = function(data) {
      var html = originalCompileTemplate.call(this, data);
      var currentCollectionId = boostPFSConfig.general.collection_id;

      if (currentCollectionId == NEW_COLLECTION_ID_TARGET || currentCollectionId == NEW_COLLECTION_ID_TARGET_1 || currentCollectionId == NEW_COLLECTION_ID_TARGET_2 || currentCollectionId == NEW_COLLECTION_ID_TARGET_3 || currentCollectionId == NEW_COLLECTION_ID_TARGET_4 ) {
        var $container = this.$element || jQ('.boost-pfs-product-list');
        var $products = $container.find('.boost-pfs-filter-product-item');

        if ($products.length > 6 && $container.find('.reeview-app-widget').length === 0) {
          jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(6));
        }
      }
      return html;
    };

    var originalAfterRender = ProductList.prototype.afterRender;
    ProductList.prototype.afterRender = function(data) {
      if (originalAfterRender) originalAfterRender.call(this, data);
      var currentCollectionId = boostPFSConfig.general.collection_id;

      if (currentCollectionId == NEW_COLLECTION_ID_TARGET || currentCollectionId == NEW_COLLECTION_ID_TARGET_1 || currentCollectionId == NEW_COLLECTION_ID_TARGET_2 || currentCollectionId == NEW_COLLECTION_ID_TARGET_3 || currentCollectionId == NEW_COLLECTION_ID_TARGET_4 ) {
        var $container = this.$element || jQ('.boost-pfs-product-list');
        var $products = $container.find('.boost-pfs-filter-product-item');

        if ($products.length > 6 && $container.find('.reeview-app-widget').length === 0) {
          jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(6));
        }
      }
    };
  }
})();

(function() {

  var COLLECTION_ID_TARGET_NEW = 32788217917;

 var CUSTOM_HTML = function(collectionId) {
  return '<div class="boost-pfs-filter-product-item boost-pfs-filter-product-item-grid boost-pfs-filter-grid-width-4 boost-pfs-filter-grid-width-mb-2">' +
           '<div class="reeview-app-widget videowise-collection-tile" ' +
             'id="reeview-app-widget_69731efec180ec041b9e51e5" ' +
             'data-widget-id="69731efec180ec041b9e51e5" ' +
             'data-collection-id="' + collectionId + '">' +
           '</div>' +
         '</div>';
};

  if (typeof ProductList !== 'undefined') {
    var originalCompileTemplate = ProductList.prototype.compileTemplate;
    ProductList.prototype.compileTemplate = function(data) {
      var html = originalCompileTemplate.call(this, data);
      var currentCollectionId = boostPFSConfig.general.collection_id;

      if (currentCollectionId == COLLECTION_ID_TARGET_NEW) {
        var $container = this.$element || jQ('.boost-pfs-product-list');
        var $products = $container.find('.boost-pfs-filter-product-item');

        if ($products.length > 6 && $container.find('.reeview-app-widget').length === 0) {
          jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(18));
        }
      }
      return html;
    };

    var originalAfterRender = ProductList.prototype.afterRender;
    ProductList.prototype.afterRender = function(data) {
      if (originalAfterRender) originalAfterRender.call(this, data);
      var currentCollectionId = boostPFSConfig.general.collection_id;

      if (currentCollectionId == COLLECTION_ID_TARGET_NEW ) {
        var $container = this.$element || jQ('.boost-pfs-product-list');
        var $products = $container.find('.boost-pfs-filter-product-item');

        if ($products.length > 6 && $container.find('.reeview-app-widget').length === 0) {
          jQ(CUSTOM_HTML(currentCollectionId)).insertAfter($products.eq(18));
        }
      }
    };
  }

})();